import { AWARD_PAYMENT } from '../../constants/general';

export const SAVE_ALLOWED_STATUSES = new Set([AWARD_PAYMENT.DRAFT, AWARD_PAYMENT.NEED_MORE_INFORMATION]);
export const SUBMIT_DISABLED_STATUSES = new Set([
  AWARD_PAYMENT.UNDER_REVIEW,
  AWARD_PAYMENT.EXPIRED,
  AWARD_PAYMENT.CANCELED,
  AWARD_PAYMENT.PAID,
  AWARD_PAYMENT.APPROVED,
]);

export const normalizePaymentRequestStatus = (status?: string | null) => {
  const s = status ?? '';
  return s.trim().toLowerCase().replace(/\s+/g, '_');
};

export const COMPLETED_STATUSES = new Set([AWARD_PAYMENT.EXPIRED, AWARD_PAYMENT.CANCELED, AWARD_PAYMENT.PAID]);
export const ACTIVE_REVIEW_STATUSES = new Set([AWARD_PAYMENT.APPROVED, AWARD_PAYMENT.NEED_MORE_INFORMATION]);

export const displayAwardStatusMap: Record<string, string> = {
  [AWARD_PAYMENT.DRAFT]: 'Draft',
  [AWARD_PAYMENT.UNDER_REVIEW]: 'Under Review',
  [AWARD_PAYMENT.NEED_MORE_INFORMATION]: 'More Info Needed',
  [AWARD_PAYMENT.APPROVED]: 'Approved - Pending Payment',
  [AWARD_PAYMENT.PAID]: 'Paid',
  [AWARD_PAYMENT.EXPIRED]: 'Expired',
  [AWARD_PAYMENT.CANCELED]: 'Closed',
};

const convertToDisplayStatus = (status: string) =>
  normalizePaymentRequestStatus(status)
    .split('_')
    .filter(Boolean)
    .map((chunk) => chunk.charAt(0).toUpperCase() + chunk.slice(1))
    .join(' ');

export const toDisplayStatus = (status: string) => displayAwardStatusMap[normalizePaymentRequestStatus(status)] ?? convertToDisplayStatus(status);
